/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BulkEditRequestBulkEditChangeArtists } from './BulkEditRequestBulkEditChangeArtists';
import {
    BulkEditRequestBulkEditChangeArtistsFromJSON,
    BulkEditRequestBulkEditChangeArtistsFromJSONTyped,
    BulkEditRequestBulkEditChangeArtistsToJSON,
} from './BulkEditRequestBulkEditChangeArtists';
import type { BulkEditRequestBulkEditContributionsInner } from './BulkEditRequestBulkEditContributionsInner';
import {
    BulkEditRequestBulkEditContributionsInnerFromJSON,
    BulkEditRequestBulkEditContributionsInnerFromJSONTyped,
    BulkEditRequestBulkEditContributionsInnerToJSON,
} from './BulkEditRequestBulkEditContributionsInner';
import type { BulkEditRequestBulkEditCorrectInner } from './BulkEditRequestBulkEditCorrectInner';
import {
    BulkEditRequestBulkEditCorrectInnerFromJSON,
    BulkEditRequestBulkEditCorrectInnerFromJSONTyped,
    BulkEditRequestBulkEditCorrectInnerToJSON,
} from './BulkEditRequestBulkEditCorrectInner';
import type { BulkEditRequestBulkEditRecordingsInner } from './BulkEditRequestBulkEditRecordingsInner';
import {
    BulkEditRequestBulkEditRecordingsInnerFromJSON,
    BulkEditRequestBulkEditRecordingsInnerFromJSONTyped,
    BulkEditRequestBulkEditRecordingsInnerToJSON,
} from './BulkEditRequestBulkEditRecordingsInner';
import type { BulkEditRequestBulkEditReleaseLink } from './BulkEditRequestBulkEditReleaseLink';
import {
    BulkEditRequestBulkEditReleaseLinkFromJSON,
    BulkEditRequestBulkEditReleaseLinkFromJSONTyped,
    BulkEditRequestBulkEditReleaseLinkToJSON,
} from './BulkEditRequestBulkEditReleaseLink';

/**
 * 
 * @export
 * @interface BulkEditRequestBulkEdit
 */
export interface BulkEditRequestBulkEdit {
    /**
     * 
     * @type {Array<BulkEditRequestBulkEditRecordingsInner>}
     * @memberof BulkEditRequestBulkEdit
     */
    recordings: Array<BulkEditRequestBulkEditRecordingsInner>;
    /**
     * 
     * @type {Array<BulkEditRequestBulkEditCorrectInner>}
     * @memberof BulkEditRequestBulkEdit
     */
    correct?: Array<BulkEditRequestBulkEditCorrectInner>;
    /**
     * 
     * @type {Array<BulkEditRequestBulkEditContributionsInner>}
     * @memberof BulkEditRequestBulkEdit
     */
    contributions?: Array<BulkEditRequestBulkEditContributionsInner>;
    /**
     * 
     * @type {BulkEditRequestBulkEditChangeArtists}
     * @memberof BulkEditRequestBulkEdit
     */
    changeArtists?: BulkEditRequestBulkEditChangeArtists;
    /**
     * 
     * @type {BulkEditRequestBulkEditReleaseLink}
     * @memberof BulkEditRequestBulkEdit
     */
    releaseLink?: BulkEditRequestBulkEditReleaseLink;
}

/**
 * Check if a given object implements the BulkEditRequestBulkEdit interface.
 */
export function instanceOfBulkEditRequestBulkEdit(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "recordings" in value;

    return isInstance;
}

export function BulkEditRequestBulkEditFromJSON(json: any): BulkEditRequestBulkEdit {
    return BulkEditRequestBulkEditFromJSONTyped(json, false);
}

export function BulkEditRequestBulkEditFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkEditRequestBulkEdit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recordings': ((json['recordings'] as Array<any>).map(BulkEditRequestBulkEditRecordingsInnerFromJSON)),
        'correct': !exists(json, 'correct') ? undefined : ((json['correct'] as Array<any>).map(BulkEditRequestBulkEditCorrectInnerFromJSON)),
        'contributions': !exists(json, 'contributions') ? undefined : ((json['contributions'] as Array<any>).map(BulkEditRequestBulkEditContributionsInnerFromJSON)),
        'changeArtists': !exists(json, 'change_artists') ? undefined : BulkEditRequestBulkEditChangeArtistsFromJSON(json['change_artists']),
        'releaseLink': !exists(json, 'release_link') ? undefined : BulkEditRequestBulkEditReleaseLinkFromJSON(json['release_link']),
    };
}

export function BulkEditRequestBulkEditToJSON(value?: BulkEditRequestBulkEdit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'recordings': ((value.recordings as Array<any>).map(BulkEditRequestBulkEditRecordingsInnerToJSON)),
        'correct': value.correct === undefined ? undefined : ((value.correct as Array<any>).map(BulkEditRequestBulkEditCorrectInnerToJSON)),
        'contributions': value.contributions === undefined ? undefined : ((value.contributions as Array<any>).map(BulkEditRequestBulkEditContributionsInnerToJSON)),
        'change_artists': BulkEditRequestBulkEditChangeArtistsToJSON(value.changeArtists),
        'release_link': BulkEditRequestBulkEditReleaseLinkToJSON(value.releaseLink),
    };
}

